export default __webpack_public_path__ + "static/media/banner.119fc3b6.jpg";